import styled, { css } from 'styled-components';

import type { EventsVariants } from 'Theme/types/components.type';

export const Event = styled.article<{ $variant: EventsVariants }>`
    ${({ theme, $variant }) => css`
        border-radius: 0.5rem;
        background: ${$variant in theme.components.events
            ? theme.components.events[$variant].background
            : theme.components.events['default'].background};
        padding: 0.75rem;

        @media ${theme.breakpoints.medium.media} {
            padding: 1rem;
        }
    `}
`;

export const EventHeading = styled.h3`
    ${({ theme }) => css`
        margin: 0;
        font-size: 1.25rem;
        line-height: 1;

        @media ${theme.breakpoints.medium.media} {
            font-size: 1.5rem;
        }

        @media ${theme.breakpoints.large.media} {
            font-size: 1.875rem;
        }
    `}
`;

export const DateWrapper = styled.div`
    ${({ theme }) => css`
        margin: 0.55rem 0;

        @media ${theme.breakpoints.large.media} {
            margin: 1.25rem 0;
        }
    `}
`;

export const Date = styled.p`
    ${({ theme }) => css`
        margin: 0;
        line-height: 1.325;
        font-size: 1.125rem;

        @media ${theme.breakpoints.large.media} {
            font-size: 1.5rem;
        }
    `}
`;

export const Flex = styled.div`
    ${({ theme }) => css`
        display: flex;
        justify-content: space-between;

        @media ${theme.breakpoints.medium.media} {
            flex-direction: column;
            align-items: flex-start;
            gap: 0.75rem;
        }

        @media ${theme.breakpoints.large.media} {
            gap: 1rem;
        }

        @media ${theme.breakpoints.xlarge.media} {
            flex-direction: row;
            gap: none;
        }
    `}
`;
